import { authedGet } from "./api";
import { api_v3_get_division_by_id } from "../utils/constants";

export const getDivision = async (divisionId, token) => {
  const url = api_v3_get_division_by_id(divisionId);
  return authedGet(url, token);
};
